import { getSelectedLeague, getSelectedSport } from 'app/imports/App.selectors'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export function LayoutHeaderLeague() {
  const league = useSelector(getSelectedLeague)
  const selectedSport = useSelector(getSelectedSport)

  const title = useMemo(() => {
    if (!league || league.length === 0) return ''

    if (league.length > 1) return ''

    let result = league[0].name
    if (selectedSport && selectedSport.length > 0) {
      if (selectedSport.length === 1) {
        result += ` ${selectedSport[0].name}`
      }
    }

    return result
  }, [league, selectedSport])

  if (!league || league.length === 0) {
    return null
  }

  return (
    <>
      <title>{`Scoreboard | ${title}`}</title>
      {title}
    </>
  )
}
